import { render, staticRenderFns } from "./SuppliesCategoryView.vue?vue&type=template&id=0acc6c71"
import script from "./SuppliesCategoryView.vue?vue&type=script&lang=js"
export * from "./SuppliesCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports